/**
 * default session types
 */
export const DEFAULT_SESSION_TYPES: SessionType[] = [
  {
    label: "Free introduction",
    price: 0,
    align_min: 30,
    length_min: 30,
    padding_min: 5,
    only_followup: false,
    enabled: true,
    order: 0,
  },
  {
    label: "Regular session",
    price: 20,
    align_min: 30,
    length_min: 30,
    padding_min: 5,
    only_followup: false,
    enabled: true,
    order: 1,
  },
  {
    label: "Follow up session",
    price: 10,
    align_min: 30,
    length_min: 30,
    padding_min: 5,
    only_followup: true,
    enabled: true,
    order: 2,
  },
];
